import { recordPath } from '@/shared/registry'

// The transcript's own module holds these; Find Completions needs the same permission and links there.
export { readLearnerRecordsPermission, transcriptPath } from '../transcripts/paths'

/** Where Find Completions lives. */
export const completionsPath = '/learner-history/completions'

/** The API's course record endpoints. */
export const courseRecordsApi = '/learner-history/v1/course-records'

/** A class enrollment's details page, Entitlements' (ENT-28). */
export function enrollmentPath(enrollmentId: string): string {
  return recordPath('entitlements', 'enrollments', enrollmentId)
}

/** A subscription's details page, such as a course assignment's, Entitlements' (ENT-10). */
export function subscriptionPath(subscriptionId: string): string {
  return recordPath('entitlements', 'subscriptions', subscriptionId)
}
